/// <reference types="@angular/localize" />


import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

posthog.init(environment.postHog, {
  api_host: 'https://app.posthog.com',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false
});

platformBrowserDynamic().bootstrapModule(AppModule)
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
